var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 88,
    height: 88,
    rx: 20,
    fill: "#EFF4FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.668 65.5H38.668C27.808 65.5 23.168 60.86 23.168 50V38C23.168 27.14 27.808 22.5 38.668 22.5H50.668C61.528 22.5 66.168 27.14 66.168 38V50C66.168 60.86 61.528 65.5 50.668 65.5ZM38.668 25.5C29.448 25.5 26.168 28.78 26.168 38V50C26.168 59.22 29.448 62.5 38.668 62.5H50.668C59.888 62.5 63.168 59.22 63.168 50V38C63.168 28.78 59.888 25.5 50.668 25.5H38.668Z",
    fill: "#002C63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.168 39.5H37.168C36.348 39.5 35.668 38.82 35.668 38C35.668 37.18 36.348 36.5 37.168 36.5H52.168C52.988 36.5 53.668 37.18 53.668 38C53.668 38.82 52.988 39.5 52.168 39.5Z",
    fill: "#002C63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.168 51.5H37.168C36.348 51.5 35.668 50.82 35.668 50C35.668 49.18 36.348 48.5 37.168 48.5H52.168C52.988 48.5 53.668 49.18 53.668 50C53.668 50.82 52.988 51.5 52.168 51.5Z",
    fill: "#002C63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.55eb9caafc061e6da8ec7fbd7a8fbfe2.svg";
export { ForwardRef as ReactComponent };